<div [ngClass]="alert.type" id="toaster">
  <div class="display">
    <div class="content">
      @if (faIconName[alert.type] != '') {
        <mat-icon
          inline
          fontSet="fa"
          class="fa-solid"
          [ngClass]="faIconName[alert.type]"
          [fontIcon]="faIconName[alert.type]"
          >
        </mat-icon>
      }
      <span
                [ngClass]="
                    alertService.isPermanent(alert)
                        ? 'content-text-close'
                        : 'content-text'
                "
        >
        <ng-content></ng-content>
      </span>

      @if (alertService.isPermanent(alert)) {
        <mat-icon
          inline
          fontSet="fa"
          class="fa-close action"
          (click)="close(alert)"
          >
        </mat-icon>
      }
    </div>

    <div class="bottom">
      @if (alert.type == alertType.STARTING || alert.type == alertType.PROGRESS) {
        <mat-progress-bar
          class="notification-progress"
          mode="indeterminate"
          color="accent"
          >
        </mat-progress-bar>
      }
    </div>
  </div>
</div>
